import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';

import { Button } from 'components/ui/Button';
import { AppRoutes } from 'config/routes';

import Dropdown from 'components/dropdown';
import { DropdownItemDefault } from 'components/dropdown/items/default';
import { HeaderTabs, Tab } from 'components/header-tabs/header-tabs';

import { BasicInformation } from './basic-information/BasicInformation';
import { Documents } from './documents/Documents';
import { Events } from './events/Events';
import { Payments } from './payments/Payments';

import { ReactComponent as CheckIcon } from 'assets/images/check.svg';
import { ReactComponent as MoreIcon } from 'assets/images/more.svg';

import { DocumentHeaderInfo } from 'components/document-header-info';
import { Icons } from 'components/icons';
import { Loader } from 'components/loader/loader';
import { NotFound } from 'components/not-found';
import { StatusDocument } from 'components/status/status-document';
import { useGetCoreDocumentsQuery, useGetDocumentStatusesQuery } from 'store/api/documents';
import { useGetMyOrganizationsQuery } from 'store/api/organizations';
import { handleDownload } from 'utils/downloads';
import s from './DetailContract.module.scss';
import { AppDocument, Organization, Signature } from 'store/api/types';

const { Home, Contracts } = AppRoutes.Dashboard;

const tabsContent = (id: string): Tab[] => [
  {
    id: 0,
    label: 'Basic information',
    path: Home + Contracts.Home + `/${id}` + Contracts.BasicInformation,
  },
  // {
  //   id: 1,
  //   disabled: true,
  //   label: 'Events',
  //   path: Home + Contracts.Home + `/${id}` + Contracts.Events,
  // },
  // {
  //   id: 2,
  //   disabled: true,
  //   label: 'Payments',
  //   path: Home + Contracts.Home + `/${id}` + Contracts.Payments,
  // },
  // {
  //   id: 3,
  //   disabled: true,
  //   label: 'Documents',
  //   path: Home + Contracts.Home + `/${id}` + Contracts.Documents,
  // },
];

export const ButtonGroup = ({ document }: { document?: AppDocument }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const viewClasses = cx(s['button'], s['button-view']);

  const handleView = () => {
    navigate(Home + Contracts.Home + Contracts.PreviewNewContract + `/${id}`);
  };

  const handleUPD = () => {
    //
  };

  return (
    <div className={s['wrapper-button']}>
      <Button
        text={t('Download')}
        icon={<Icons.Download />}
        className={cx(s['button'])}
        displayType="outlined-tetriary"
        onClick={async () => {
          const data = document?.tbd ?? [];

          // Loop through each signature
          data.forEach((item, signatureIndex) => {
            const body = item?.content ?? [];
            const type = item?.type === 'base' ? 'file' : 'signature';
            const format = type === 'file' ? '.xml' : '.txt';
            const fileName =
              type === 'file'
                ? `${document?.title ?? ''} №${document?.number}`
                : `${type}_${signatureIndex + 1}`;

            handleDownload({
              content: body,
              fileName: fileName,
              format: format,
            });
          });
        }}
      />

      <Button className={viewClasses} onClick={handleView}>
        {t('View')}
      </Button>
      {false && (
        <Dropdown
          button={
            <div className={s['wrapper-more']}>
              <MoreIcon />
            </div>
          }
        >
          <DropdownItemDefault onClick={handleUPD}>
            <div className={s['dropdown-row']}>
              {t('Form an UPD')}
              <div>
                <CheckIcon />
              </div>
            </div>
          </DropdownItemDefault>
        </Dropdown>
      )}
    </div>
  );
};

export const DetailContract = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data: myOrganizations } = useGetMyOrganizationsQuery();
  const currentOrganization: Organization | undefined = myOrganizations?.[0];

  const { data: [document] = [], isFetching } = useGetCoreDocumentsQuery(
    { ids: [id ?? ''] },
    { skip: !id },
  );

  const { data: statuses } = useGetDocumentStatusesQuery();

  const status = statuses?.find((item) => item.id === document?.statusId);
  const isOwner = (currentOrganization?.id ?? '') === (document?.orgOwner?.id ?? '');

  const contractor = isOwner ? document?.contractors?.[0]?.name : document?.orgOwner?.name;

  if (isFetching) {
    return <Loader size="ultra" />;
  }

  if (!document) {
    return <NotFound title="Document not found" notFoundTitle="" hasSearch={false} />;
  }

  return (
    <div className={s['container']}>
      <div className={s['wrapper-header']}>
        <div className={s['header-title']}>
          <div className={s['breadcrumbs']}>
            Договоры /
            <DocumentHeaderInfo document={document} />
          </div>
          <ButtonGroup document={document} />
        </div>
        <div className={s['header-footer']}>
          <div className={s['wrapper-info']}>
            {/* <span className={s['contract-type']}>{t('Partnership agreement')}</span> */}
            {/* {document?.contractors?.[0]?.name && (
              <span className={s['contract-type']}>{document?.contractors?.[0]?.name}</span>
            )} */}
            <StatusDocument text={status?.alias} isOwner={isOwner} />
          </div>
          {document?.contractors?.[0]?.name && <span className={s['name']}>{contractor}</span>}
        </div>
      </div>
      <div className={s['wrapper-content']}>
        <HeaderTabs tabs={tabsContent(id ?? '')} type="detail" />

        <Routes>
          <Route
            path={Contracts.BasicInformation}
            element={<BasicInformation document={document} />}
          />
          {/* <Route path={Contracts.Events} element={<Events />} />
          <Route path={Contracts.Payments} element={<Payments />} />
          <Route path={Contracts.Documents} element={<Documents />} /> */}
        </Routes>
      </div>
    </div>
  );
};
